var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('api-loader',{attrs:{"method":"get","url":"v1/DataAdmin/export-excel","response-type":"blob"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var blob = ref.result;
var responseHeaders = ref.responseHeaders;
return [_c('b-card',[_c('b-btn',{on:{"click":function($event){return _vm.downloadBlob(blob, responseHeaders)}}},[_vm._v("\n          Download\n        ")])],1)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a3b7933","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/dataAdmin/views/ExcelExportView.vue
// module id = null
// module chunks = 